import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { partnerServer } from '../config'
import { fetcher } from '../context/utils'
import { ICityCardDetails } from '../interfaces/cityCardDetails'

const useCityCard = (id: string = '') => {
  const [state, setState] = useState<ICityCardDetails>()
  const { data, error } = useSWR(
    `${partnerServer}/partner-api/place-site?id=${id}`,
    fetcher
  )

  useEffect(() => {
    if (data) {
      setState(data)
    }
  }, [data])
  return state
}

export default useCityCard
